// extracted by mini-css-extract-plugin
export var quantityInput = "_og-0";